export default "__VITE_ASSET__DnSkpFPm__"